export default "__VITE_ASSET__B_jf_JnU__"